import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const QCInspectionWizardRoute: RouteType = {
  name: "QCInspectionWizard",
  path: "/workflows/qc-inspection",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "QC Inspection",
      component: () => import("./QCInspectionWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./QCInspectionWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for QC inspection
      const qcStore = rootStore.qcStore as ServiceStore;
      const panelStore = rootStore.panelStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const jobStore = rootStore.jobStore as ServiceStore;

      await Promise.all([
        qcStore?.find(),
        panelStore?.find(),
        productsStore?.find(),
        jobStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for QC inspection:", error);
      return false;
    }
  },
};

export default QCInspectionWizardRoute;